import { render, staticRenderFns } from "./SaveModal.vue?vue&type=template&id=3f10b740&scoped=true&"
import script from "./SaveModal.vue?vue&type=script&lang=js&"
export * from "./SaveModal.vue?vue&type=script&lang=js&"
import style0 from "./SaveModal.vue?vue&type=style&index=0&id=3f10b740&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f10b740",
  null
  
)

export default component.exports